import { render, staticRenderFns } from "./tabZfdetails3.vue?vue&type=template&id=fabfd43c&"
import script from "./tabZfdetails3.vue?vue&type=script&lang=js&"
export * from "./tabZfdetails3.vue?vue&type=script&lang=js&"
import style0 from "./tabZfdetails3.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "tabZfdetails3.vue"
export default component.exports